<template>
  <div class="top">
    <div class="left">
      <div class="fit-my-car">
        <i class="icon icon-fitmycar"></i>
        <div v-if="!vehicle.full_name">{{ provideDetails }}</div>
        <div v-else>{{ vehicle.full_name }}</div>
      </div>
      <div class="text">
        <a :href="fullUrl" v-if="!vehicle.full_name">{{ fitMyCar }}</a>
        <a dusk="blackbar_changeVehicle" :href="fullUrl + '?change'" v-else>{{ changeVehicle }}</a>
      </div>
    </div>
    
    <a :href="maxtraxUrl" class="brand-link" v-if="isBrandBannerActive">
      <img src="/cdn/images/site/banner-maxtrax.png" />
    </a>
    <a :href="tredUrl" class="brand-link" v-if="isBrandBannerActive">
      <img src="/cdn/images/site/banner-tred.png" />
    </a>
    <a :href="rockyMountsUrl" class="brand-link" v-if="isBrandBannerActive">
      <img src="/cdn/images/site/banner-rockymounts.png" />
    </a>

    <div class="divider" v-if="isBrandBannerActive"></div>
    
    <cart-header
      :netsuite_url="netsuite_url"
      :netsuite_app_url="netsuite_app_url"
      :enable_b2c="enable_b2c"
      :enable_b2b="enable_b2b"
      :cart_url="netsuite_app_url"
      :country="culture"
      >
    </cart-header>

    <wishlist-header 
      :netsuite_url="netsuite_url"   
      :enable_b2c="enable_b2c"
      :enable_b2b="enable_b2b">
    </wishlist-header>
  
    <div class="right-country">
        <div v-html="countrySelectorHtml"></div>
    </div>

    <div class="right" v-if="!checkingLoginStatus">
      <div class="text">
        <a :href="storeHref" v-if="userIsLoggedIn && !isMobileDevice()"> {{ profileCompanyName ? profileCompanyName : loginLabel }}</a>
        <a :href="storeHref" v-if="userIsLoggedIn && isMobileDevice()">{{ loginLabel }} </a>
        <a :href="loginHref" v-if="!userIsLoggedIn">{{ loginLabel }}</a>
        <!-- a href="#" v-if="userIsLoggedIn" @click.prevent="logoutMethod">
          {{
          label_logout
          }}
        </a -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "black-bar",
  props: [
    "link",
    "provide-details",
    "fit-my-car",
    "change-vehicle",
    "enable_b2c",
    "enable_b2b",
    "hide_dealer",
    "enable_spare_parts",
    "enable_custom_b2c",
    "netsuite_url",
    "netsuite_app_url",
    "netsuite_account_url",
    "reset_cookie_user_vehicle_id",
    "label_logout",
    "login",
    "dealer",
    "is_dealer",
    "is_spare_part_enabled",
    "cart_url_params",
    "brand_links",
    "culture",
    // "selected_vehicle_id",
  ],
  data() {
    return {
      cartmode: false,
      isDealerLoggedIn: 0,
      cultureArr : [{'lngid':'4', 'culture':'en-us'}, {'lngid':'5', 'culture':'en-nz'}, {'lngid':'7', 'culture':'en-au'}],
      loginHref: "/",
      countrySelectorHtml: '',
    };
  },
  created() {},
  beforeDestroy() {
    if (this.countryObserver) {
      this.countryObserver.disconnect();
    }
  },
  mounted() {
    this.countryObserver = new MutationObserver(() => {
      const el = this.$el.querySelector('.country');
      if (el) {
        el.classList.remove('align-left', 'align-right');
        const rect = el.getBoundingClientRect();
        if (rect.right > window.innerWidth - 100) {
          el.classList.add('align-right');
        } else {
          el.classList.add('align-left');
        }
      }
    });

    this.countryObserver.observe(this.$el, { childList: true, subtree: true });

    const el = document.getElementById('country-selector-html');
    if (el) {
      this.countrySelectorHtml = el.innerHTML;
    }

    if(this.isDealerWithWrongSession) {
      this.toggleDealerStatus('enable');
    }
    this.setLoggedInHref();
    if (this.enable_b2b == 1 || this.enable_b2c == 1) {
      this.$store.dispatch("auth/getProfile", this.netsuite_app_url);
    }
    if (this.reset_cookie_user_vehicle_id === "1") {
      this.selectVehicle({});
    } else {
      this.getVehicleFromStore();
    }

    if(this.userIsLoggedIn && this.$store.state.auth.profile.email && this.$store.state.auth.profile.subsidiary){
      var culture_tmp1 = window.culture;
      for (var i = 0; i < this.cultureArr.length; i++) {
          if(this.cultureArr[i].lngid == this.$store.state.auth.profile.subsidiary){
            culture_tmp1 = this.cultureArr[i].culture;
            break;
          }
      }
      if(window.culture != culture_tmp1) {
        window.location = window.location.origin + '/' + culture_tmp1 + '/';
      };
    }

    setTimeout(() => {
        if(this.cartNoAccess) {
          let menuItems = document.getElementsByClassName("my-account-item");
          if(menuItems)
            for (var i = 0; i < menuItems.length; i++) {
              menuItems[i].style.display = 'none';
            }
        }
    });


    this.keepTheSessionAlive();

    this.$store.commit('cart/setCartUrlParams', this.cart_url_params);
    this.$store.commit('cart/checkB2B', this.enable_b2b);
    this.$store.commit('cart/checkB2C', this.enable_b2c);
    this.$store.commit('cart/checkCustomB2C', this.enable_custom_b2c);
    this.$store.commit('cart/checkDealerUser', this.is_dealer);
    this.$store.commit('cart/checkSparePartsSettings', this.is_spare_part_enabled);
    this.$store.commit('cart/setNetsuiteURL', this.netsuite_url);
  },
  computed: {
    isBrandBannerActive() {
      return this.brand_links?.isEnabled;
    },
    maxtraxUrl() {
      return this.brand_links?.maxtraxUrl;
    },
    tredUrl() {
      return this.brand_links?.tredUrl;
    },
    rockyMountsUrl() {
      return this.brand_links?.rockyMountsUrl;
    },    
    bannerLocation () {
      return window.location.origin + '/' + culture;
    },
    storeHref(){
      if(this.cartNoAccess)
        return window.location.origin + '/';
      else
        return this.netsuite_account_url + 'my_account.ssp';
    },
    loginLabel() {

        if(this.enable_b2c == 1){
            return this.login;
        }

        if(this.enable_b2b == 1){
            return this.dealer;
        }

        if(this.enable_spare_parts == 1){
            return this.login;
        }
    },
    vehicle() {
      return this.$store.state.solutions.selectedVehicle;
    },
    fullUrl() {
      if(this.$store.state.cart.isDealer &&  this.$store.state.cart.isSiteB2B) {
        return `/${window.culture}/fit-a-vehicle`;
      }
      return `/${window.culture}${this.link}`;
    },
    netSuiteProfile() {
      return this.$store.state.auth.profile;
    },
    userIsLoggedIn() {
      return this.$store.getters["auth/userIsLoggedIn"];
    },
    checkingLoginStatus() {
      if (this.hide_dealer == 1 || (this.enable_b2c == 0 && this.enable_b2b == 0 && this.enable_spare_parts == 0)) {
        return true; // this hides the
      } else {
        return this.$store.state.auth.checkingStatus;
      }
    },
    userType() {
      return this.$store.getters["auth/userType"];
    },
    cartNoAccess() {
      return this.$store.getters["auth/cartNoAccess"];
    },
    profileCompanyName() {
      if (this.$store.state.auth.profile.type == 'COMPANY') {
        setTimeout(function(){
          var elmTopHeight = document.querySelector('header.head .top') ? document.querySelector('header.head .top').offsetHeight : 42;
          var elmBottomHeight = document.querySelector('header.head .bottom') ? document.querySelector('header.head .bottom').offsetHeight : 59;
          var elmSearchHeight = document.querySelector('form.desktop-search.loaded.dealer-search') ? document.querySelector('form.desktop-search.loaded.dealer-search').offsetHeight : 90;

          var elm = document.querySelector('div.content.dealerSearch.isDealer') !== null;
          if (elm) {
            document.querySelector('div.content.dealerSearch.isDealer').style.paddingTop = (elmTopHeight + elmBottomHeight + elmSearchHeight) + "px";
          }
        });
        return this.$store.state.auth.profile.companyname;
      } else {
        return this.$store.state.auth.profile.firstname + " " + this.$store.state.auth.profile.lastname;
      }
    },
    isDealerWithWrongSession() {
      return (this.userType == 'B2B') && (this.is_dealer == 0);
    }
  },
  watch: {
    userType(newType, oldType) {
      let state =
        newType == "B2B" ? "enable" : newType == "B2C" ? "disable" : "disable"; // fallback to disable
      this.toggleDealerStatus(state);
    }
  },
  methods: {
    isMobileDevice() {
      return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
    },
    logoutMethod() {
      this.$store.dispatch("auth/logout", this.netsuite_app_url);
    },
    async setLoggedInHref() {
      let culture = window.culture ? "/" + window.culture : "";
      let url = "/api/isDealer/";
      let response = await axios.get(url);
      this.isDealerLoggedIn = response.data.is_dealer;

      if (this.isDealerLoggedIn == 0) {
          if(!this.userIsLoggedIn) {
              //this.toggleDealerStatus('disable');
          }
        //this.loginHref = this.netsuite_url + "app/checkout.ssp?is=login&login=T&fragment=login-register";

          if((this.enable_b2c == 1) || (this.enable_b2b == 1 && this.enable_b2c == 1)) {
            this.loginHref = culture + "/login";
          }
          else if(this.enable_b2b == 1 && this.enable_b2c == 0) {
            this.loginHref = culture + "/dealer";
          }
          else if(this.enable_b2c == 0 && this.enable_b2b == 0 && this.enable_spare_parts == 1) {
            this.loginHref = culture + "/login";
          }
       }
    },
    toggleDealerStatus(status) {

      // let culture = window.culture ? "/" + window.culture : "";

      fetch(`/api/isDealer/${status}`)
        .then(raw => {
          return raw.json();
        })
        .then(response => {
          // reload the page - set true to force reload without browser cache
          // but this can cause issues in some browsers so needs to be tested
            let culture_tmp = null;
            // netsuite always returns profile.isLoggedIn as true(T)!!!
            if (this.$store.state.auth.profile.email) {
                if (this.$store.state.auth.profile.subsidiary == '5') {
                    culture_tmp = 'en-nz';
                } else if (this.$store.state.auth.profile.subsidiary == '7') {
                    culture_tmp = 'en-au';
                } else if (this.$store.state.auth.profile.subsidiary == '4') {
                    if (window.location.href.includes("/en-us")) {
                        culture_tmp = 'en-us';
                    } else if (window.location.href.includes("/es-us")) {
                        culture_tmp = 'es-us'
                    } else {
                        culture_tmp = 'en-us'
                    };
                }
            }

            if(culture_tmp && !this.isDealerWithWrongSession) {
              window.location = window.location.origin + '/' + culture_tmp + '/';
            }
            else {
              window.location.reload(true);
            }
        });
    },
    getVehicleFromStore() {
      if (this.$store.state.solutions.selectedVehicle.vehicleId) {
        var vehicle = this.$store.state.solutions.selectedVehicle;
        this.selectVehicle(vehicle);
      }
    },

    async selectVehicle(vehicle) {
      this.$store.commit("solutions/setSelectedVehicle", vehicle);
      console.log('selectVehicle ', vehicle);
    },
    async keepTheSessionAlive() {
      let self = this;
      let counter = 0;
      let maxAttempt =  this.userType == 'B2B' ? 120 : 30;

      if ((this.enable_b2b == 1 && this.userType == 'B2B')|| this.enable_b2c == 1) {
        setInterval(function () {
          if (counter < maxAttempt) {
            self.$store.dispatch("auth/getProfile", self.netsuite_app_url);
          } else {
            clearInterval(this);
          }
          counter++;
        }, 60000);
      }
    }
  }
};
</script>
